// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-Book----details-module---list---3-YNz","techItem":"src-components-Book----details-module---techItem---2VtIp","title":"src-components-Book----details-module---title---hgW44","definition":"src-components-Book----details-module---definition---3xPQy","link":"src-components-Book----details-module---link---1yRs1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Book/details.module.css
// module id = 323
// module chunks = 35783957827783